import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import styles from "./footerForm.module.scss";

import { registerUser } from "actions/users";

import cx from "classnames";
import _ from "lodash";

export default function Footerform() {
  const dispatch = useDispatch();

  const error = useSelector((state) =>
    _.get(state, `users.registration.error`)
  );
  const loading = useSelector((state) =>
    _.get(state, `users.registration.loading`)
  );
  const registered = useSelector((state) =>
    _.get(state, `users.registration.success`)
  );
  const userData = useSelector((state) =>
    _.get(state, `users.registration.item`)
  );

  const [state, setState] = useState({
    email: "",
    errors: {},
    success: false,
  });

  const formSumbit = (e) => {
    e.preventDefault();
    window.location.href = 'https://www.paperflite.com/cleverstory/book-a-demo';
    // const errors = validateForm();
    // if (Object.keys(errors).length != 0) {
    //   setState((state) => {
    //     return {
    //       ...state,
    //       errors: errors.email,
    //     };
    //   });

    //   return;
    // }

    // var request = {
    //   email: state.email,
    // };
    // dispatch(registerUser(request));
  };

  const handleEmail = (e) => {
    setState((state) => {
      return {
        ...state,
        email: e.target.value,
      };
    });
  };

  // useEffect(() => {
  //   if (registered) {
  //     window.location.replace(
  //       `https://www.paperflite.com/cleverstory/book-a-demo?${userData.email}`
  //     );
  //   }
  //   resetForm();
  // }, [registered]);

  const validateForm = () => {
    let errors = {};
    const { email } = state;

    if (!email || email.trim == "") {
      errors.email = "Enter a valid email id";
    }

    const regex =
      /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    if (!regex.test(email)) {
      errors.email = "Enter a valid email id";
    }

    if (email.includes("@qq.")) {
      errors.email = "Enter a valid work email id";
    }

    return errors;
  };

  const resetForm = () => {
    setState((state) => {
      return {
        email: "",
        errors: {},
        success: false,
      };
    });
  };

  return (
    <>
      <div className={styles.contentWrapper}>
        <div className={styles.textSection}>
          <h2 className={styles.heading}>Build yours on cleverstory</h2>
          <p className={cx(styles.paragraph)}>
           Let's fly you to the moon and back
          </p>
        </div>

        <div className={styles.formSection}>
          <form className={styles.signup_form} data-hs-cf-bound="true">
            <input
              name="source"
              type="hidden"
              value=""
              data-gaconnector-tracked="true"
            />
            {/* <input
              type="email"
              name="email"
              placeholder="Your email address"
              onChange={handleEmail}
              data-gaconnector-tracked="true"
            /> */}
            {error && <div class={styles.errorMessage}>{error}</div>}
            {_.size(state.errors) > 0 && (
              <div class={styles.errorMessage}>{state.errors}</div>
            )}
            <input
              class="btn btn-light btn-primary btn-large signUpBtn"
              onClick={formSumbit}
              type="submit"
              value= "Request a Demo"
              data-original-title="Request a Demo"
              data-gaconnector-tracked="true"
            />
          </form>
        </div>

        <div className={styles.formimages}>
          <img src="/images/footer/boat.png" className={styles.boatimg} />
          <img src="/images/footer/birds.png" className={styles.birdimg} />
          <img src="/images/footer/leaf-2.png" className={styles.leaf} />
          <img src="/images/footer/leaf-2.png" className={styles.bigLeaf} />
          <img
            className={cx(styles.ft_dot1, styles.hide)}
            src="/images/footer/trans.png"
          />
          <img
            className={cx(styles.ft_dot2, styles.hide)}
            src="/images/footer/trans.png"
          />
          <img
            className={cx(styles.ft_dot3, styles.hide)}
            src="/images/footer/trans.png"
          />
          <img
            className={cx(styles.ft_dot4, styles.hide)}
            src="/images/footer/trans.png"
          />
          <img
            className={cx(styles.ft_dot5, styles.hide)}
            src="/images/footer/trans.png"
          />
          <img
            className={cx(styles.ft_dot6, styles.hide)}
            src="/images/footer/trans.png"
          />
          <img
            className={cx(styles.ft_dot7, styles.hide)}
            src="/images/footer/trans.png"
          />
          <img
            className={cx(styles.ft_dot8, styles.hide)}
            src="/images/footer/trans.png"
          />
        </div>
      </div>
    </>
  );
}
